/*
 * @description:
 * @author: Jason Wong
 * @since: 2020-05-26 11:35:11
 */
/*
 * @author: Jason Wong
 * @desc: global variables for environment,includes mode and options of mock,etc.
 */

const mode = {
  production: "production",
  development: "development",
};

export default {
  mode: process.env.NODE_ENV,
  useMock: Boolean(process.env.VUE_APP_MOCK),
  name: process.env.VUE_APP_NAME,
  code: process.env.VUE_APP_CODE,
  title: process.env.VUE_APP_TITLE,
  apiBaseUri: process.env.VUE_APP_API_URI,
  apiWithCredentials: Boolean(process.env.VUE_APP_API_WITH_CREDENTIALS),
  heartBeatFilePath: process.env.VUE_APP_HEART_BEAT_FILE_PATH,
  heartBeatUri: process.env.VUE_APP_HEART_BEAT_URL,
  websocketUri: process.env.VUE_APP_WEBSOCKET_URI,
};

function consoleIfDevelopment(...args) {
  // console.log("#-# consoleIfDevelopment",process.env.NODE_ENV);
  if (process.env.NODE_ENV === mode.development) {
    // console.log.apply(null,args);
  }
}

function errorIfDevelopment(...args) {
  if (process.env.NODE_ENV === mode.development) {
    // console.error.apply(null,args);
  }
}

export { mode, consoleIfDevelopment, errorIfDevelopment };
